import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { language, switchLanguage } = useLanguage();

  return (
    <div className="language-switcher">
      <button
        onClick={() => switchLanguage('es')}
        className={`lang-btn ${language === 'es' ? 'active' : ''}`}
        aria-label="Cambiar a Español"
      >
        ES
      </button>
      <span className="lang-divider">/</span>
      <button
        onClick={() => switchLanguage('en')}
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        aria-label="Switch to English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
